const StringFormatter = function (template, replacements = {}) {
    const regExp = /<%([^%>]+)?%>/g;
    let match;
    // eslint-disable-next-line no-cond-assign
    while (match = regExp.exec(template)) {
        if (replacements.hasOwnProperty(match[1])) {
            template = template.replace(match[0], replacements[match[1]]);
        }
        else {
            template = template.replace(match[0], '');
        }
    }
    return template;
};
export default StringFormatter;
//# sourceMappingURL=StringFormatter.js.map